export const HELP_LINKS_FF = 'rollout.ai.ai_help_links';

export const BIZAI_CHAT_FF = 'pkg.ai.bizai_chat';

export const AICHAT_ATTR = 'data-aichat';

export const DEFAULT_QUESTION_KEY = 'help.default_question';

export const HELP_WORKFLOW_NAME = 'answer_help_question';
